import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)

import VueSlideoutPanel from "vue2-slideout-panel";
Vue.use(VueSlideoutPanel);

import TextareaAutosize from 'vue-textarea-autosize'
Vue.use(TextareaAutosize)

import VueDaumPostcode from "vue-daum-postcode"
Vue.use(VueDaumPostcode)

import './plugins/axios'
import './plugins/common'
window.$ = window.jQuery = require('jquery');

import VueMoment from 'vue-moment';
Vue.use(VueMoment)

import filters from '@/plugins/filters';
Vue.mixin(filters);

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

Vue.config.productionTip = false
console.log("----------------"+process.env.VUE_APP_ENV_MODE + "----------------")
if ( process.env.VUE_APP_ENV_MODE !== 'PRODUCTION'){
  console.log(process.env)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
